import { WasteType } from '@/enums/waste-type';

export interface WasteTypeConfig {
  label: string;
  color: string;
  enumValue: WasteType;
}

export const WASTE_TYPES: WasteTypeConfig[] = [
  {
    label: 'waste.type.staff.meal',
    color: '#2563EB',
    enumValue: WasteType.STAFF_MEAL
  },
  {
    label: 'waste.type.treat',
    color: '#059669',
    enumValue: WasteType.TREAT
  },
  {
    label: 'waste.type.breakage',
    color: '#D97706',
    enumValue: WasteType.BREAKAGE
  },
  {
    label: 'waste.type.expired',
    color: '#DC2626',
    enumValue: WasteType.EXPIRED
  }
];

export const getWasteTypeConfig = (
  wasteType: string
): WasteTypeConfig | undefined =>
  WASTE_TYPES.find((w) => w.enumValue === wasteType);
